export enum saleCollection {
    MAYA_LIN_SALE= "maya-lin",
    MAYA_LIN_PROD= "ghost-forest-seedlings",
    JOY_DIVISION_SALE= "cp1919",
    SUI_SALE= "sui",
  }